const { helpers } = require("vuelidate/lib/validators");

export const passwordValid = helpers.regex("passwordValid", /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[ a-zA-Z\d!@#$%^]{8,}$/);
export const phoneNumber = helpers.regex('phoneNumber', /^(\+?)(\([0-9]*\))?(((\s|-)?[0-9]+)*)$/);